<template>
    <v-dialog v-model="getModalExcluirPedidoCompra" scrollable max-width="720px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Excluir Pedido</v-card-title>
            <v-card-text>
                <h3 align="center"> Tem certeza que deseja excluir?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalExcluirPedidoCompra(false)" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="excluirPedidoCompra(getPedidoCompra)" outlined>Excluir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalExcluirPedidoCompra',
                'getPedidoCompra'
            ])
        },
        methods: {
            ...mapActions([
                'excluirPedidoCompra',
                'setModalExcluirPedidoCompra'
            ])
        },
        
    }
</script>